import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { RCCButton, RCCGrid, RCCHookToast, RCCInput, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import Modal from "src/components/Modal";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { useConfirmModal } from "../ConfirmModal/context";
import { IRefModalTFA } from "./interface";

const ModalTFA: React.ForwardRefRenderFunction<IRefModalTFA> = (_, ref) => {
	const {translate} = useTranslation();
	const {addToast} = RCCHookToast();
	const {confirm} = useConfirmModal();
	const modalTFA = useRef<RCCRefModalProps>(null);
	const {handleSubmit: handleSubmitTFA, register: registerTFA, reset: resetTFA } = useForm();
	const userId = useRef<number>(0);
	const onCallbackTFA = useRef<Function>(() => {});
	const openTFAModal = async (efa005Id: number, onCallback: Function) => {
		resetTFA();
		userId.current = efa005Id;
		onCallbackTFA.current = onCallback;
		modalTFA.current?.openModal();	
	};
	const onSubmitTFA = async (dt: any) => {
		try{
			modalTFA.current?.setLoadingButton();

			await RCCServicesApi.postRequest({
				method: "TwoFactorAuthenticationPublic/Validate",
				body: {
					code: dt.code,
					efa005Id: userId.current
				}
			});
			modalTFA.current?.resetLoadingButton();
			modalTFA.current?.closeModal();
			onCallbackTFA.current();
		}catch(err){
			modalTFA.current?.resetLoadingButton();
			standardErrorMessages(err, translate("Erro na autenticação em dois fatores"), addToast);
		}	
	};
	const onRemoveTFA = () => {
		confirm(
			translate("Exclusão de autenticação em dois fatores"), 
			`${translate("Será enviado um email com instruções para remover o dispositivo cadastrado com a autenticação em dois fatores. Deseja prosseguir")} ?`,
			async () => {
				await RCCServicesApi.postRequest({
					method: "TwoFactorAuthenticationPublic/RequestDelete",
					urlParameters: {
						efa005Id: userId.current
					}
				});

				addToast({
					color: "green",
					description: translate("Email com instruções enviado com sucesso"),
					title: translate("Sucesso")
				});
			},
			(err) => {
				standardErrorMessages(err, translate("Erro ao enviar email"), addToast);
			},
			false
		);
	};

	useImperativeHandle(ref, () => ({
		openTFAModal
	}));

	return(
		<>
			{/* Modal Delete */}
			<Modal
				ref={modalTFA}
				header={{
					title: translate("Autenticação em dois fatores"),
					icon: {
						name: "shield"
					}
				}}
				onSubmit = {handleSubmitTFA(onSubmitTFA)} 
				styleInline={`
                width: 50vw;
                min-width: 300px;
                height: 280px;
                position: absolute;
                top: 60px;
            `}
			>
				<Title color="defaultColor">{translate("Insira o código de verificação em dois fatores para prosseguir com o login")}</Title>
				<RCCGrid container item alignItems="center" justifyContent="center">
					<RCCGrid container item xs={12} sm={8}>
						<RCCInput 
							register={registerTFA}
							name="code"
							label={translate("Código de verificação")}
							maxLength={6}
							styleInline={`
							height: 100px !important;
							input{
								height: 100px !important;
								font-size: 75px !important;
								text-align: center;
							}
						`}
							required
						/>
						<RCCGrid container item alignItems="center" justifyContent="flex-end">
							<RCCButton
								color="transparent"
								styleInline={`
									color: var(--input-font-color);
									transition: 100ms ease;

									&:hover{
										color: var(--purple);
										font-weight: bold;
									}
								`}
								onClick={onRemoveTFA}
							>
								{translate("Perdi meu dispositivo chave de autenticação em dois fatores")}
							</RCCButton>
						</RCCGrid>
					</RCCGrid>
				</RCCGrid>
			</Modal>
		</>
    
	);};

export default forwardRef(ModalTFA);
